import React from 'react'

// Mui
import { Typography } from '@mui/material'

// Prop Type
import PropTypes from 'prop-types'

// ==============================================================
const TableHeader = ({ header }) => {
  return (
    <Typography
      fontWeight="bold"
      variant="caption"
      sx={{ whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      {header}
    </Typography>
  )
}

TableHeader.prototype = {
  header: PropTypes.string.isRequired,
}

export default TableHeader
